<template>
    <component :is="routerView" :code="code" :skin="skin" />
</template>

<script>
import BoardList from "./board-list.vue";
import BoardView from "./board-view.vue";
export default {
    props: ["code", "skin"],
    components: {
        BoardList,
        BoardView,
    },
    computed: {
        routerView(){
            return this.$route.params._board ? "board-view" : "board-list";
        }
    }
}
</script>